import AnyAction from 'store/anyActions';
import { AgentsState } from './agents.state';
import AgentsTypes from './agents.types';

const defaultState: AgentsState = {
    agents: [],
    agentsActive: false,
    agentsError: false,
    agentsLoading: false,
};

export default function(state: AgentsState = defaultState, action: AnyAction) : AgentsState {
    switch (action.type) {
        case AgentsTypes.SHOW_AGENTS:
            return { ...state, agentsActive: !state.agentsActive };
        case AgentsTypes.GET_AGENTS:
            return { ...state, agents: [...action.payload.agents], agentsLoading: false };
        case AgentsTypes.SET_AGENTS_ERROR:
            return { ...state, agentsError: action.payload.error };
        case AgentsTypes.SET_AGENTS_LOADING:
            return { ...state, agentsLoading: action.payload.loading };
        case AgentsTypes.CLEAR_AGENTS:
            return { ...state, agents: [] };
        case AgentsTypes.FILTER_AGENTS:
            return { ...state, agentsFilter: {...state.agentsFilter,...action.payload}, agents: [] };
        default:
            return state;
    }
}
